(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jeje-1010-promo"]) return;
  try {
    
  if (!customElements.get('jeje-1010')) {
    customElements.define('jeje-1010', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.editor = this.dataset.editor === 'true';
        this.start = Number(this.dataset.start) * 1000;
        this.end = Number(this.dataset.end) * 1000;
        this.refreshState();
        const options = { signal: this.controller.signal };
        if (this.dialog) {
          this.querySelectorAll('[data-promo-close], [data-promo-cta]').forEach(node => node.addEventListener('click', () => this.dialog.close(), options));
          this.dialog.addEventListener('click', event => {
            const rect = this.dialog.getBoundingClientRect();
            if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = this.previousOverflow || '';
            if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
          }, options);
          if (!this.editor || this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(), this.editor ? 100 : 2500);
        }
        this.interval = setInterval(() => this.refreshState(), 15000);
        document.addEventListener('visibilitychange', () => this.refreshState(), options);
      }
      refreshState() {
        const now = Date.now();
        this.expired = now >= this.end && !this.editor;
        this.hidden = this.expired;
        if (this.expired && this.dialog?.open) this.dialog.close();
        const active = now >= this.start;
        this.key = 'jeje-1010-2026-' + (active ? 'live' : 'preview');
        this.querySelectorAll('[data-promo-upcoming]').forEach(node => node.hidden = active);
        this.querySelectorAll('[data-promo-active]').forEach(node => node.hidden = !active);
      }
      open() {
        this.refreshState();
        if (this.expired || !this.isConnected || !this.dialog || this.dialog.open || this.shown) return;
        if (!this.editor) {
          try { if (localStorage.getItem(this.key) || sessionStorage.getItem(this.key)) return; } catch (error) {}
          const blockers = [...document.querySelectorAll('dialog[open], [role="dialog"], #shopify-pc__banner, .main-search, .mobile-navigation-drawer, cart-drawer')];
          const blocked = blockers.some(node => {
            const box = node.getBoundingClientRect();
            const style = getComputedStyle(node);
            return node !== this.dialog && box.width > 0 && box.height > 0 && box.left < innerWidth && box.right > 0 && box.top < innerHeight && box.bottom > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
          });
          if (document.hidden || blocked || document.activeElement?.matches('input, textarea, select')) {
            this.timer = setTimeout(() => this.open(), 2000);
            return;
          }
        }
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.shown = true;
        if (!this.editor) { try { localStorage.setItem(this.key, '1'); } catch (error) { try { sessionStorage.setItem(this.key, '1'); } catch (ignored) {} } }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearInterval(this.interval);
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeje-december-promo"]) return;
  try {
    

  if (!customElements.get('jeje-december')) {
    customElements.define('jeje-december', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.editor = this.dataset.editor === 'true';
        this.start = Number(this.dataset.start) * 1000;
        this.end = Number(this.dataset.end) * 1000;
        this.refreshState();
        const options = { signal: this.controller.signal };
        if (this.dialog) {
          this.querySelectorAll('[data-promo-close], [data-promo-cta]').forEach(node => node.addEventListener('click', () => this.dialog.close(), options));
          this.dialog.addEventListener('click', event => {
            const rect = this.dialog.getBoundingClientRect();
            if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
          }, options);
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = this.previousOverflow || '';
            if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
          }, options);
          if (!this.editor || this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(), this.editor ? 100 : 2500);
        }
        this.interval = setInterval(() => this.refreshState(), 15000);
        document.addEventListener('visibilitychange', () => this.refreshState(), options);
      }
      refreshState() {
        const now = Date.now();
        this.expired = now >= this.end && !this.editor;
        this.hidden = this.expired;
        if (this.expired && this.dialog?.open) this.dialog.close();
        const active = now >= this.start;
        this.key = 'jeje-december-gold-2026-' + (active ? 'live' : 'preview');
        this.querySelectorAll('[data-promo-upcoming]').forEach(node => node.hidden = active);
        this.querySelectorAll('[data-promo-active]').forEach(node => node.hidden = !active);
      }
      open() {
        this.refreshState();
        if (this.expired || !this.isConnected || !this.dialog || this.dialog.open || this.shown) return;
        if (!this.editor) {
          try { if (localStorage.getItem(this.key) || sessionStorage.getItem(this.key)) return; } catch (error) {}
          const blockers = [...document.querySelectorAll('dialog[open], [role="dialog"], #shopify-pc__banner, .main-search, .mobile-navigation-drawer, cart-drawer')];
          const blocked = blockers.some(node => {
            const box = node.getBoundingClientRect();
            const style = getComputedStyle(node);
            return node !== this.dialog && box.width > 0 && box.height > 0 && box.left < innerWidth && box.right > 0 && box.top < innerHeight && box.bottom > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
          });
          if (document.hidden || blocked || document.activeElement?.matches('input, textarea, select')) {
            this.timer = setTimeout(() => this.open(), 2000);
            return;
          }
        }
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.shown = true;
        if (!this.editor) { try { localStorage.setItem(this.key, '1'); } catch (error) { try { sessionStorage.setItem(this.key, '1'); } catch (ignored) {} } }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearInterval(this.interval);
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeje-edit-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jeje-edit-page')) {
    customElements.define('jeje-edit-page', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const cards = [...this.querySelectorAll('[data-edit-card]')];
        const select = this.querySelector('select');
        const filter = this.querySelector('[data-edit-filter]');
        const empty = this.querySelector('[data-edit-empty]');
        if (!select || !filter || !empty) return;
        const sizes = [...new Set([...this.querySelectorAll('[data-edit-size]')].map(el => el.dataset.editSize))];
        sizes.forEach(size => select.add(new Option(size, size)));
        filter.hidden = sizes.length === 0;
        const update = () => {
          cards.forEach(card => {
            card.hidden = select.value !== '' && ![...card.querySelectorAll('[data-edit-size]')].some(el => el.dataset.editSize === select.value);
          });
          empty.hidden = cards.some(card => !card.hidden);
        };
        select.addEventListener('change', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeje-last-pieces"] && !Shopify.designMode) return;
  try {
    
  function initJejeLast(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('.jeje-last__card')];
    const select = root.querySelector('select');
    const sizes = [...new Set([...root.querySelectorAll('[data-lp-size]')].map(el => el.dataset.lpSize))];
    sizes.forEach(size => select.add(new Option(size, size)));
    root.querySelector('.jeje-last__filter').hidden = sizes.length === 0;
    const update = () => {
      cards.forEach(card => { card.hidden = select.value !== '' && ![...card.querySelectorAll('[data-lp-size]')].some(el => el.dataset.lpSize === select.value); });
      root.querySelector('.jeje-last__empty').hidden = cards.some(card => !card.hidden);
    };
    select.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('[data-jeje-last]').forEach(initJejeLast);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jeje-last]').forEach(initJejeLast));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jeje-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jeje-welcome')) {
    customElements.define('jeje-welcome', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.controller = new AbortController();
        this.key = 'jeje-korea-welcome-v1';
        this.editor = this.dataset.editor === 'true';
        const options = { signal: this.controller.signal };
        this.querySelector('[data-welcome-open]').addEventListener('click', () => this.open(), options);
        this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.querySelector('[data-welcome-cta]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.remember();
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.querySelector('[data-welcome-copy]').addEventListener('click', async () => {
          const input = this.querySelector('input');
          const status = this.querySelector('[role="status"]');
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = status.dataset.copied;
          } catch {
            input.focus(); input.select(); status.textContent = status.dataset.copyFailed;
          }
        }, options);
        if (this.editor) {
          if (this.dataset.preview === 'true') this.timer = setTimeout(() => this.open(), 300);
          return;
        }
        try {
          const until = Number(localStorage.getItem(this.key) || sessionStorage.getItem(this.key));
          if (until > Date.now()) return;
        } catch { return; }
        this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay) * 1000);
      }
      remember() {
        if (this.editor) return;
        const until = String(Date.now() + Number(this.dataset.days) * 86400000);
        try { localStorage.setItem(this.key, until); } catch { try { sessionStorage.setItem(this.key, until); } catch {} }
      }
      tryOpen() {
        if (!this.isConnected) return;
        const blockers = document.querySelectorAll('dialog[open], [role="dialog"], #shopify-pc__banner, .main-search, .mobile-navigation-drawer, cart-drawer');
        const blocked = [...blockers].some(element => element !== this.dialog && element.getBoundingClientRect().width > 0 && element.getBoundingClientRect().height > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none' && element.getBoundingClientRect().left < innerWidth && element.getBoundingClientRect().right > 0 && element.getBoundingClientRect().top < innerHeight && element.getBoundingClientRect().bottom > 0 && Number(getComputedStyle(element).opacity) > 0);
        if (document.hidden || blocked || document.activeElement?.matches('input, textarea, select')) {
          this.timer = setTimeout(() => this.tryOpen(), 1000);
          return;
        }
        this.open();
      }
      open() {
        if (this.dialog.open || !this.isConnected) return;
        clearTimeout(this.timer);
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.remember();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
